import { useEffect, useRef, useState } from 'react';

export const useSticky = () => {
  const [isSticky, setIsSticky] = useState(false);

  const toolbarSentinelRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsSticky(entry.boundingClientRect.top < -1);
      },
      { threshold: [0] },
    );

    if (toolbarSentinelRef.current) {
      observer.observe(toolbarSentinelRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  return {
    isSticky,
    toolbarSentinelRef,
  };
};
